import classNames from 'classnames';
import { t } from 'ttag';

import Title from '@ui/Title';
import { Button } from '@ui/Button';
import {
  Modal,
  ModalProps,
} from '@ui/Modal';

// styles
import s from './LastEnabledDeliveryServiceModal.sss';

export const LastEnabledDeliveryServiceModal: React.FC<ModalProps> = (props) => (
  <Modal
    {...props}
    className={classNames(s.root, props.className)}
  >
    <Title type="h3" bold={false}>{t`Спосіб доставки`}</Title>

    <p className={s.text}>
      {t`У вас має залишитися хоча б один спосіб доставки.`}
    </p>

    <Button
      className={s.button}
      onClick={props.onRequestClose}
    >
      {t`Добре`}
    </Button>
  </Modal>
);

export default LastEnabledDeliveryServiceModal;
